export default __webpack_public_path__ + "static/media/viberlink-black.c4a42ddb.png";